export const GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_PENDING = 'GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_PENDING';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_FULFILLED = 'GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_FULFILLED';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_REJECTED = 'GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_REJECTED';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_PENDING =
  'GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_PENDING';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_FULFILLED =
  'GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_FULFILLED';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_REJECTED =
  'GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_REJECTED';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_PENDING = 'GET_PIP_EPOS_DATA_MISSING_WEEKS_PENDING';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_FULFILLED = 'GET_PIP_EPOS_DATA_MISSING_WEEKS_FULFILLED';
export const GET_PIP_EPOS_DATA_MISSING_WEEKS_REJECTED = 'GET_PIP_EPOS_DATA_MISSING_WEEKS_REJECTED';
export const PATCH_RESET_STRIKE_COUNTER_PENDING = 'PATCH_RESET_STRIKE_COUNTER_PENDING';
export const PATCH_RESET_STRIKE_COUNTER_FULFILLED = 'PATCH_RESET_STRIKE_COUNTER_FULFILLED';
export const PATCH_RESET_STRIKE_COUNTER_REJECTED = 'PATCH_RESET_STRIKE_COUNTER_REJECTED';

const initialState = {
  outlets: [],
  postcodeplanObjectives: [],
  pipEposDataMissingWeeks: [],
  fetching: false,
  fetched: false,
  errors: {}
};

export default function pipEposDataMissingWeeksReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_PENDING:
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_PENDING:
    case PATCH_RESET_STRIKE_COUNTER_PENDING:
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case PATCH_RESET_STRIKE_COUNTER_FULFILLED:
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pipEposDataMissingWeeks: action.payload.data
      };
    }
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        postcodeplanObjectives: action.payload.pip_objectives
      };
    }
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        outlets: action.payload.outlets
      };
    }
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_REJECTED:
    case PATCH_RESET_STRIKE_COUNTER_REJECTED:
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_POSTCODEPLAN_OBJECTIVES_REJECTED:
    case GET_PIP_EPOS_DATA_MISSING_WEEKS_OUTLETS_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    default:
      return state;
  }
}
